import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  INVENTORY_SUMMARY_SET_ITEMS,
  INVENTORY_SUMMARY_SET_TOTAL_PAGE,
  INVENTORY_SUMMARY_SET_CURRENT_PAGE,
  INVENTORY_SUMMARY_SET_OUTLETS,
  INVENTORY_SUMMARY_SET_ROW_ITEMS,
  INVENTORY_SUMMARY_SET_INGREDIENTS
} from 'actions/inventory/summary/constants'

let initialState = {
  items: [],
  rowItems: [],
  totalPage: null,
  currentPage: null,
  outlets: [],
  ingredients: []
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case INVENTORY_SUMMARY_SET_ROW_ITEMS:
      return {...state, rowItems: payload.items}
    case INVENTORY_SUMMARY_SET_ITEMS:
      return {...state, items: payload.items}
    case INVENTORY_SUMMARY_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.page}
    case INVENTORY_SUMMARY_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.page}
    case INVENTORY_SUMMARY_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case INVENTORY_SUMMARY_SET_INGREDIENTS:
      return {...state, ingredients: payload.ingredients}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/inventory/summary.js